import { Pipe, PipeTransform } from '@angular/core';
import { CardinalMapping, MapperUtil } from '../util/mapper.util';

@Pipe({
  name: 'decToStr',
})
export class DecToStrPipe implements PipeTransform {
  transform(value: number, mapping: CardinalMapping): any {
    return MapperUtil.decToStr(value, mapping) ?? '-';
  }
}
